import React, { useCallback } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  MenuItem,
  InputAdornment
} from '@mui/material';
import { Close, DateRange } from '@mui/icons-material';
import LoaderMain from '../../Onboarding/shared/LoaderMain';
import useModalGridDashboardVOPHook from './useModalGridDashboardVOPHook';

const ModalGridDashboardVOP = ({ modalGridVOP, setModalGridVOP, setAlerta }) => {
  const {
    isPending,
    meses,
    totais,
    anos,
    selectedYear,
    handleChangeAno,
    formatarMoeda,
    formatarPorcentagem
  } = useModalGridDashboardVOPHook({ modalGridVOP, setAlerta, setModalGridVOP });

  const onClose = useCallback(() => setModalGridVOP(false), [setModalGridVOP]);
  const onChangeAno = useCallback(e => handleChangeAno(e.target.value), [handleChangeAno]);

  if (!modalGridVOP) return null;

  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose} aria-labelledby="vop-dialog-title">
      <DialogTitle id="alert-dialog-title" className="texto-cor-principal texto-negrito">
        <Box className="items-centralizados-esquerda borda-bottom-2-gray pad-topbot-10">
          VOP Mensal
          {' - '}
          {modalGridVOP.nomeCliente.toUpperCase()}
          <IconButton onClick={onClose} className="float-right margin-neg-top-5">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <TextField
            select
            size="small"
            value={selectedYear}
            onChange={onChangeAno}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <DateRange fontSize="small" />
                </InputAdornment>
              )
            }}
          >
            {anos.map(ano => (
              <MenuItem key={ano} value={ano}>
                {ano}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {isPending ? (
          <LoaderMain tipoLoader="float" tipoImagem="circulo" />
        ) : (
          <>
            <Grid container spacing={2} mb={4} mt={4}>
              <Grid item xs={4} textAlign="center">
                <Typography className="font-size-15 texto-cinza-claro">Média Mensal</Typography>
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(totais.mediaMensal)}
                </Typography>
              </Grid>
              <Grid item xs={4} textAlign="center">
                <Typography className="font-size-15 texto-cinza-claro">Total Acumulado</Typography>
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(totais.totalAcumulado)}
                </Typography>
              </Grid>
              <Grid item xs={4} textAlign="center">
                <Typography className="font-size-15 texto-cinza-claro">Maior VOP</Typography>
                <Typography className="texto-semi-negrito font-size-18">
                  {formatarMoeda(totais.maiorVOP)}
                </Typography>
              </Grid>
            </Grid>

            <TableContainer className="tableExibirProdutos texto-cor-cinza-escuro">
              <Table>
                <TableHead className="azul-claro-background">
                  <TableRow>
                    <TableCell className="texto-semi-negrito" align="left">
                      Mês
                    </TableCell>
                    <TableCell className="texto-semi-negrito" align="center">
                      VOP
                    </TableCell>
                    <TableCell className="texto-semi-negrito" align="center">
                      Variação
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {meses.map(({ mes, valorVOP, variacaoVOP }) => (
                    <TableRow key={mes}>
                      <TableCell className="texto-semi-negrito borda-direita">{mes}</TableCell>
                      <TableCell align="center">{formatarMoeda(valorVOP)}</TableCell>
                      <TableCell align="center">
                        <Typography color={variacaoVOP > 0 ? 'success.main' : 'error.main'}>
                          {formatarPorcentagem(variacaoVOP)}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(ModalGridDashboardVOP);
